import type { ClientChatMessage } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo, type FC } from 'react';
import { StyleSheet, View } from 'react-native';

import { ChatMessageContent } from '@/features/chats/components/ChatMessageContent';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    layout: { flexDirection: 'row' },
    speechBubble: {
      backgroundColor: theme.colors.surfaceContainerLowest,
      color: theme.colors.onSurfaceVariant,
      borderRadius: 20,
      borderBottomLeftRadius: 8,
      paddingHorizontal: 16,
      paddingVertical: 8,
      marginHorizontal: 16,
      marginVertical: 8,
      flexShrink: 1,
      maxWidth: '90%'
    }
  });

type Props = {
  message: ClientChatMessage;
};

export const ReceivedChatMessage: FC<Props> = ({ message }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={styles.layout}>
      <View style={styles.speechBubble}>
        <ChatMessageContent
          message={message}
          textColor={theme.colors.onSurfaceVariant}
        />
      </View>
    </View>
  );
};
